import { Icon } from '@/components/entities/Sprite';
import { cn } from '@/utils/cn';
import { DESKTOP_SECOND_BLOCK_ICONS, MOBILE_SECOND_BLOCK_ICONS, PAYMENT_ICONS } from '../consts/paymentIcons';

const PaymentBlock = () => {
  return (
    <div className="flex flex-col xxl:flex-row justify-start items-center relative xxl:gap-21.25 3xl:justify-center max-xl:mt-0.25">
      <div className="flex items-center justify-center gap-3 lg:gap-21.25 3xl:ml-55 lg:ml-[0.5313rem]">
        {PAYMENT_ICONS.map((icon, index) => (
          <Icon
            name={icon.name}
            key={icon.name}
            className={cn('size-15 md:size-18', index >= 4 && 'hidden xxl:block')}
          />
        ))}
      </div>
      <div className="flex items-center justify-center gap-2 -mt-3.5 xxl:hidden">
        <div className="grid grid-flow-col auto-cols-max items-center gap-3">
          {MOBILE_SECOND_BLOCK_ICONS.map(icon => (
            <Icon name={icon.name} key={icon.name} className="size-15 text-white" />
          ))}
        </div>
        <p className="font-medium text-white leading-[120%] text-sm -mb-0.25">Crypto</p>
      </div>
      <div className="hidden xxl:flex gap-3">
        {DESKTOP_SECOND_BLOCK_ICONS.map(icon => (
          <Icon name={icon.name} key={icon.name} className="size-8 text-main-800" />
        ))}
      </div>
    </div>
  );
};
export default PaymentBlock;
